var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVersion5 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M471.5,700h-243c-60.8,0-118.2-23.8-161.4-67.1C23.8,589.6,0,532.3,0,471.5V0h471.5c60.8,0,118.2,23.8,161.4,67.1 c43.3,43.3,67.1,100.6,67.1,161.4v242.9c0,60.8-23.8,118.2-67.1,161.4C589.6,676.2,532.3,700,471.5,700z M100,100v360.8 c0,76.8,62.5,139.2,139.2,139.2h221.5c76.8,0,139.2-62.5,139.2-139.2V239.2c0-76.8-62.5-139.2-139.2-139.2H100L100,100z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498,292.4c0-49.7-40.6-90.4-90.4-90.4H202v205.6c0,49.7,40.6,90.4,90.4,90.4h115.2c49.8,0,90.4-40.6,90.4-90.4V292.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVersion5);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/version5.0f2626760bddb96da614d67bb40d5849.svg";